import { FC } from 'react';

import { buildBookingDeepLink } from '@/utils';
import { Paragraph } from '@/UI/Atoms/Paragraph';
import { BookingDeepLinkButtonProps } from './BookingDeepLinkButton.types';
import * as St from './BookingDeepLinkButton.styles';

export const BookingDeepLinkButton = ({
  action,
  companySlug,
  countryCode,
  confirmationCode,
  children,
  ...anchorProps
}: BookingDeepLinkButtonProps) => {
  const href = buildBookingDeepLink({ companySlug, countryCode, confirmationCode, action });
  const { target, rel, ...restAnchorProps } = anchorProps;
  const safeRel = target === '_blank' ? [rel, 'noopener', 'noreferrer'].filter(Boolean).join(' ') : rel;

  return (
    <St.LinkButton href={href} target={target} rel={safeRel} {...restAnchorProps}>
      <Paragraph align="center" weight="light">
        {children}
      </Paragraph>
    </St.LinkButton>
  );
};
